var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12937_33462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2052 3.99656H7.6652L9.4352 2.22656L11.2052 3.99656ZM7.6877 15.0291H11.1827L9.4352 16.7766L7.6877 15.0291ZM4.5752 5.20406L1.2002 13.7991H2.5802L3.2702 11.9616H7.1027L7.7927 13.7991H9.1727L5.8052 5.20406H4.5752ZM3.7277 10.7316L5.1827 6.84656L6.6377 10.7316H3.7277ZM11.7977 12.6066H16.3877V13.7991H9.9902V12.8316L14.4302 6.41156H10.0202V5.21156H16.2452V6.15656L11.7977 12.6066V12.6066Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12937_33462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameSort);
export default __webpack_public_path__ + "static/media/nameSort.7c057cdd1294a9eae69c123eb108a540.svg";
export { ForwardRef as ReactComponent };